import ComponentButton from 'src/components/Button'
import { Field as ComponentField } from 'src/components/Field'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Button = styled(ComponentButton)`
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.green3};
  box-shadow: none;
`

export const Label = styled.label`
  margin-bottom: 6px;
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const Field = styled(ComponentField)`
  height: 10px;
  padding: 13px;
  border-radius: 16px;
  border-color: ${({ theme }) => theme.colors.darkGray};
  background-color: inherit;

  &:focus {
    box-shadow: none;
  }
`
